<template>
  <v-container>
    <v-layout column>
      <v-flex>
        <v-toolbar flat color="transparent">
          <v-spacer />
          <v-text-field
            v-model="keyword"
            :disabled="searchFunc == null"
            @input="execFilter"
            placeholder="search"
            style="max-width: 300px;"
            append-icon="search"
          />
        </v-toolbar>
      </v-flex>
      <v-flex style="height: 75vh; overflow: auto">
        <v-data-table
          :headers="headers"
          :items="filteredIncompleteCampaingList"
          :pagination.sync="sortOptions"
          :rows-per-page-items="[-1]"
          :loading="loading"
          hide-actions
          class="elevation-1"
        >
          <template v-slot:headers="props">
            <th
              v-for="header in props.headers"
              :width="header.width"
              :key="header.text"
              :class="[
                'column sortable px-2',
                sortOptions.descending ? 'desc' : 'asc',
                header.value === sortOptions.sortBy ? 'active' : '',
              ]"
              :aria-sort="header.sortable ? '' : 'none'"
              @click="changeSort(header)"
            >
              {{ header.text }}
              <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
            </th>
          </template>

          <template slot="items" slot-scope="props">
            <tr>
              <td>
                <v-btn
                  @click="submit(props)"
                  small
                  color="primary"
                  class="mr-2 ml-0"
                >
                  入稿完了
                </v-btn>
              </td>
              <td>
                {{ props.item.anLineItemId }}
              </td>
              <td>
                {{ props.item.name }}
              </td>
              <td>
                <v-layout>
                  <AppMenuIcon
                    :menu-type="props.item.menuType"
                    class="align-self-center"
                  />
                  <AppMenuType :value="props.item.menuType" />
                </v-layout>
              </td>
              <td>
                {{ props.item.advertiserName }}
              </td>
              <td>
                {{ props.item.insertionOrderName }}
              </td>
              <td>
                {{ props.item.createdTime }}
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <div>未入稿キャンペーンはありません</div>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import campaignSearch from '@/components/Admin/Util/campaignSearch'
export default {
  name: 'CampaignList',
  props: {
    loading: {
      type: Boolean,
    },
    incompleteCampaingList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        {
          text: '',
          value: '',
          width: '5%',
          sortable: false,
        },
        {
          text: 'ID',
          value: 'anCampaignId',
          width: '5%',
          sortable: true,
        },
        {
          text: 'キャンペーン名',
          value: 'name',
          width: '20%',
          sortable: true,
        },
        {
          text: 'メニュー種別',
          value: 'menuType',
          width: '15%',
          sortable: true,
        },
        {
          text: '広告主名',
          value: 'advertiserName',
          width: '20%',
          sortable: true,
        },
        {
          text: '案件名',
          value: 'insertionOrderName',
          width: '15%',
          sortable: true,
        },
        {
          text: '作成日時',
          value: 'createdTime',
          width: '20%',
          sortable: true,
        },
      ],
      filteredIncompleteCampaingList: this.incompleteCampaingList,
      searchFunc: undefined,
      keyword: '',
      sortOptions: {
        sortBy: 'createdTime',
        descending: false,
      },
    }
  },
  watch: {
    incompleteCampaingList() {
      this.makeCampaignSearch()
      this.execFilter()
    },
  },
  created() {
    this.makeCampaignSearch()
    this.execFilter()
  },
  methods: {
    async submit(campaign) {
      this.$emit('submit', campaign.item)
    },
    makeCampaignSearch() {
      this.searchFunc = campaignSearch({ items: this.incompleteCampaingList })
    },
    execFilter() {
      if (this.keyword.length === 0) {
        this.filteredIncompleteCampaingList = this.incompleteCampaingList
      } else {
        this.filteredIncompleteCampaingList = this.searchFunc.search(
          this.keyword,
        )
      }
    },
    changeSort(header) {
      if (!header.sortable) return

      const column = header.value
      if (this.sortOptions.sortBy === column) {
        this.sortOptions.descending = !this.sortOptions.descending
      } else {
        this.sortOptions.sortBy = column
        this.sortOptions.descending = false
      }
    },
  },
}
</script>
